/*
 * CODE GENERATED AUTOMATICALLY WITH GraphQL Codegen
 * THIS FILE SHOULD NOT BE EDITED MANUALLY.
 */
import { IMarketingBannersBanner } from '@r-client/data/graphql-types';
import {
  BaseQueryModel,
  IQueryModelOpts,
  useGqlClient,
  useQuery,
} from '@r-client/shared/data/client';

import {
  GetMarketingBannersDocument,
  IGetMarketingBannersQuery,
  IGetMarketingBannersQueryVariables,
} from './types';
export type { IMarketingBannersBanner };

export type IGetMarketingBannersQueryOpts =
  IQueryModelOpts<IGetMarketingBannersQueryVariables>;

export class GetMarketingBannersQuery extends BaseQueryModel<
  IGetMarketingBannersQuery,
  IGetMarketingBannersQueryVariables
> {
  // This is fine. Here we explicitly change interface for query
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(opts: IGetMarketingBannersQueryOpts) {
    super(opts);
  }

  get query() {
    return GetMarketingBannersDocument;
  }
}
export function useGetMarketingBannersQuery(
  opts?: Omit<IGetMarketingBannersQueryOpts, 'client'>
) {
  const client = useGqlClient();
  return useQuery(
    () => new GetMarketingBannersQuery({ ...opts, client }),
    opts?.variables
  );
}
